import React from "react";
import { useNavigate } from "react-router-dom";
import "./AboutUs.css";

import aboutImg from "../../../../assets/images/home/aboutus/rightimg.png";
import tick from "../../../../assets/icons/orangeTick.svg"; 
import { resolveMediaUrl } from "../../../../utils/media";

const fallbackAboutUs = {
  tag: "ABOUT US",
  titleLine1: "Building Iraq with Trusted",
  titleLine2: "Gypsum Manufacturing",
  description:
    "IRQGYP is a leading Iraqi company specialized in gypsum products and modern construction solutions, serving local and regional markets with a strong commitment to quality, sustainability, and long-term partnerships.",
  item1: "Highest Quality Standard",
  item2: "Highest Quality Standard",
  item3: "Partnership System",
  item4: "Team of Professionals",
  item5: "Training Academy",
  item6: "Proudly Iraqi Expertise",
  buttonText: "Know More",
  buttonLink: "/about",
  image: "",
};

const hasSectionData = (section) => {
  if (!section || typeof section !== "object") return false;
  return Object.values(section).some((value) => {
    if (value === null || typeof value === "undefined") return false;
    if (typeof value === "string") return value.trim().length > 0;
    return true;
  });
};

const AboutUs = ({ content }) => {
  const navigate = useNavigate();
  const aboutContent = hasSectionData(content) ? content : fallbackAboutUs;
  const imageSrc = resolveMediaUrl(aboutContent.rightImage || aboutContent.image) || aboutImg;

  return (
    <section className="about">

      <div className="about-container">

        <div className="about-left">

          <span className="about-tag tag">{aboutContent.tag}</span>

          <h2>
            {aboutContent.titleLine1} <br />
            <span>{aboutContent.titleLine2}</span>
          </h2>

          <p>
            {aboutContent.description}
          </p>

          <div className="about-list">

            <div className="about-col">
              <div className="item">
                <img src={tick} alt="" />
                <span>{aboutContent.item1}</span>
              </div>
              <div className="item">
                <img src={tick} alt="" />
                <span>{aboutContent.item2}</span>
              </div>
              <div className="item">
                <img src={tick} alt="" />
                <span>{aboutContent.item3}</span>
              </div>
            </div>

            <div className="about-col">
              <div className="item">
                <img src={tick} alt="" />
                <span>{aboutContent.item4}</span>
              </div>
              <div className="item">
                <img src={tick} alt="" />
                <span>{aboutContent.item5}</span>
              </div>
              <div className="item">
                <img src={tick} alt="" />
                <span>{aboutContent.item6}</span>
              </div>
            </div>

          </div>

          <button className="buttongyp" type="button" onClick={() => navigate(aboutContent.buttonLink || "/about")}>
            {aboutContent.buttonText}
          </button>

        </div>

        <div className="about-right">
          <img src={imageSrc} alt="About" />
        </div>

      </div>

    </section>
  );
};

export default AboutUs;